import React from "react";
import { Stack, Box } from "@mui/material";
import { ShimmerThumbnail, ShimmerText, ShimmerTitle } from "react-shimmer-effects";

interface ListShimmerProps {
    rows?: number; // number of shimmer items
    height?: number; // height of each item
}

const ListShimmer: React.FC<ListShimmerProps> = ({
    rows = 1,
    height = 100,
}) => {
    return (
        <Stack spacing={2}>
            {Array.from({ length: rows }).map((_, index) => (
                <Box
                    key={index}
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        padding: 2,
                        borderRadius: 2,
                        boxShadow: 1,
                        backgroundColor: "#fff",
                        minHeight: height,
                    }}
                >
                    {/* Profile image shimmer */}
                    <Box sx={{ width: 60, height: 60, borderRadius: '50%', overflow: 'hidden', mr: 2 }}>
                        <ShimmerThumbnail />
                    </Box>

                    {/* Text shimmer */}
                    <Stack spacing={1} flex={1}>
                        <Box sx={{ width: '40%', height: 16, borderRadius: 1, overflow: 'hidden' }}>
                            <ShimmerText line={1} />
                        </Box>
                        <Box sx={{ width: '30%', height: 12, borderRadius: 1, overflow: 'hidden' }}>
                            <ShimmerText line={1} />
                        </Box>
                    </Stack>

                    <Box sx={{ width: 20, height: 20, borderRadius: 1, overflow: 'hidden', ml: 2 }}>
                        <ShimmerThumbnail />
                    </Box>

                </Box>
            ))}
            
        </Stack>
    );
};

export default ListShimmer;
